import createStatDirective from './pvtrack/stat.directive';
import marquee from './marquee';
import input from './int'
import pvtrack from '../services/pvtrack.service';
const statDirective = createStatDirective(pvtrack.directiveTrack);
const Marquee = marquee();
pvtrack.startClickTrack();
const directives = [statDirective, Marquee,input];
function install(Vue) {
  console.log(directives);
  directives.forEach((directive) => {
    Vue.directive(directive.name, directive);
  });
}
export default { install };
